/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Hook for managing notifications state
 */

"use client";

import { useState } from "react";
import type { NotificationRow, RealtimeStatus } from "./types";

/**
 * Hook for managing notifications state
 */
export function useNotificationsState() {
  const [notifications, setNotifications] = useState<NotificationRow[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [realtimeStatus, setRealtimeStatus] =
    useState<RealtimeStatus>("disconnected");

  return {
    notifications,
    setNotifications,
    unreadCount,
    setUnreadCount,
    isLoading,
    setIsLoading,
    error,
    setError,
    realtimeStatus,
    setRealtimeStatus,
  };
}
